import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ToastableItem } from '@radioking/shared/common-services';

import {
  CreateBreakFailure,
  CreateBreakSuccess,
  DeleteBreakFailure,
  DeleteBreakSuccess,
  DeleteSelectedBreaksFailure,
  DeleteSelectedBreaksSuccess,
  EditBreakFailure,
  EditBreakSuccess,
  NoContentSelected,
  TooltipNoContent,
} from './states/break.actions';

export const breakToasts: ToastableItem[] = [
  {
    action: CreateBreakSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.CREATE_BREAK_SUCCESS'),
  },
  {
    action: CreateBreakFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.CREATE_BREAK_ERROR'),
  },
  {
    action: EditBreakSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.EDIT_BREAK_SUCCESS'),
  },
  {
    action: EditBreakFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.EDIT_BREAK_ERROR'),
  },
  {
    action: DeleteBreakSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_BREAK_SUCCESS'),
  },
  {
    action: DeleteBreakFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_BREAK_ERROR'),
  },
  {
    action: DeleteSelectedBreaksSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_SELECTED_BREAK_SUCCESS'),
  },
  {
    action: DeleteSelectedBreaksFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_SELECTED_BREAK_ERROR'),
  },
  {
    action: NoContentSelected,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.NO_BREAK_CONTENT_SELECTED'),
  },
  {
    action: TooltipNoContent,
    level: 'error',
    translationKey: marker('SCHEDULE.PLANNING.NO_PROGRAM_PLAYLIST_TRACK'),
  },
];
